/**
 * SEO head updater — writes <title>, meta description, OG tags from a CMS block.
 */
import { useEffect } from "react";
import { useCms } from "@/lib/useCms";

function set(name, content, prop = false) {
  if (!content) return;
  const attr = prop ? "property" : "name";
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function Seo({ blockKey, fallback = {} }) {
  const seo = useCms(blockKey, fallback);
  useEffect(() => {
    if (!seo) return;
    if (seo.title) document.title = seo.title;
    set("description", seo.description);
    set("og:title", seo.og_title || seo.title, true);
    set("og:description", seo.og_description || seo.description, true);
    if (seo.og_image) set("og:image", seo.og_image, true);
    set("robots", seo.robots || "index,follow");
  }, [seo]);
  return null;
}
